import { render, staticRenderFns } from "./MenuNav.vue?vue&type=template&id=494446df&scoped=true"
import script from "./MenuNav.vue?vue&type=script&lang=js"
export * from "./MenuNav.vue?vue&type=script&lang=js"
import style0 from "./MenuNav.vue?vue&type=style&index=0&id=494446df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494446df",
  null
  
)

export default component.exports